import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { routePath } from 'routes'
import { TokenStorage} from 'services/tokenService'

// @ts-ignore
const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = () => TokenStorage.isAuthenticated()

  const defaultRoute= process.env.REACT_APP_ENABLE_LOGIN != undefined ?  routePath.AUTH: routePath.ESTIMATES_START_PAGE;

  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: defaultRoute,
              state: { from: props.location }
            }}
          />
        )
      }
    />
  )
}

export default PrivateRoute
